module.exports = __webpack_public_path__ + "static/media/promo-code-tick.337653f4.svg";